// Module
var code = "<!-- Input -->\n<cjs-input ref=\"inputText\" inputType=\"text\" class=\"flex-container-row flex-item-auto\"></cjs-input>";
// Exports
module.exports = code;